import { render, staticRenderFns } from "./entry-info-person.vue?vue&type=template&id=bb7fee8a&scoped=true&"
import script from "./entry-info-person.vue?vue&type=script&lang=js&"
export * from "./entry-info-person.vue?vue&type=script&lang=js&"
import style0 from "./entry-info-person.vue?vue&type=style&index=0&id=bb7fee8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7fee8a",
  null
  
)

export default component.exports